import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeActionKey } from '../traitTypes/TraitTypeActionKey';
import { eventRegistry } from '../../Registry';
import { createsTrait, traitCreatedBy } from '../TraitRegistryDependencies';
export class TraitRegistryEventFromTraitRegistry extends TraitRegistryCategory {
    label = 'Registry Events';
    constructor(parent) {
        super(parent);
        this.setObjectProperties();
        super.init();
    }
    setObjectProperties() {
        return this.registry.eventRegistry.allLeafs.forEach(item => {
            const init = {
                eventType: item.key,
                aspectsTemplate: item.params,
                label: item.handlerName
            };
            if (item.derivesFrom) {
                init.createTraits = ({ at }) => [
                    {
                        key: eventRegistry.registry_object[item.derivesFrom].handlerName,
                        value: 'triggerDerivedEvents'
                    }
                ];
                const createdKey = this.registry.eventRegistry.registry_object[item.derivesFrom].handlerName;
                createsTrait[item.handlerName] = [createdKey];
                const old = traitCreatedBy[createdKey] || [];
                traitCreatedBy[createdKey] = [item.handlerName, ...old];
            }
            const reg = () => new TraitTypeAspectEventHandler(init);
            this[item.handlerName] = reg;
        });
    }
    get leafs() {
        const updateOnEventAdd = this.registry.eventRegistry.allLeafs;
        this.setObjectProperties();
        return super.leafs;
    }
    get allLeafs() {
        return super.allLeafs;
    }
}
export class TraitTypeAspectEventHandler extends TraitTypeActionKey {
    multiple = true;
    eventType;
    constructor(init = {}) {
        super(init);
        Object.assign(this, init);
    }
}
